export default "__VITE_ASSET__oJIBh8Ih__"